module.exports = __webpack_public_path__ + "static/media/LogoMayorQ.04d7c9a7.svg";